export default personalInfoSponsorLink

/** @ngInject */
function personalInfoSponsorLink($window) {
    return ({
        restrict: 'E',
        scope: {
            customerId: '<',
        },
        template: require('./personalInfoSponsorLink.jade')(),
        link($scope) {
            $scope.sponsorUrl = `${$window.location.origin}/parrainage/${$scope.customerId}`
            $scope.displayedSponsorUrl = `${$window.location.hostname}/parrainage/${$scope.customerId}`
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/personalInformation/component/personalInfoSponsorLink.js